/**
 * Asking the engine to leave out the staves whose parts are silent.
 *
 * An engine that condenses a score does it per system, which is the only place the
 * question can be answered: whether a staff is worth drawing depends on which bars share
 * a system, and where the systems break is the engine's decision and not the document's.
 * So the document says whether it wants condensing (`Layout.hideEmptyStaves`) and the
 * engine does it.
 *
 * Verovio will do it, but only when the document it is drawing says it may, and only MEI
 * can say it: the flag is `optimize` on `<scoreDef>`, and nothing in MusicXML sets it --
 * verified against Verovio 6.3.0, where the same eight-part score drops 96 drawn staves to
 * 36 from MEI and drops none at all from MusicXML however the option is set. So a score
 * that wants condensing is loaded twice: once as the MusicXML every other feature goes
 * through, then again as the engine's own MEI with the flag written into it. The engine's
 * ids survive that second pass, which is what keeps the drawn page clickable.
 *
 * An engine that cannot hand its MEI back draws every staff instead. That is the safe way
 * to fail: a page with too many staves on it can still be edited.
 */

/** The first `<scoreDef>` of a document, told that its systems may be condensed. */
export function optimized(mei: string): string {
  const at = mei.indexOf("<scoreDef");
  if (at < 0) return mei;
  const end = mei.indexOf(">", at);
  if (end < 0) return mei;
  const tag = mei.slice(at, end);
  if (tag.includes("optimize=")) return mei;
  return `${mei.slice(0, at + "<scoreDef".length)} optimize="true"${mei.slice(at + "<scoreDef".length)}`;
}
